import { AmenityType, AMENITY_TAG_OPTIONS } from "../../../Types/amenityTypes"
import ProviderSettingsField from "../../FormFields/ProviderSettings/ProviderSettingsField"
import QuickForm from "../QuickForm/QuickForm"

export default function AmenityForm(props: {
    disabled: boolean,
    onSubmit: (v: any) => Promise<any>,
    initialValues?: Partial<AmenityType>,
    uploadImageFn?: (v: any) => Promise<string>,
}) {
    const {
        disabled,
        onSubmit,
        initialValues,
        uploadImageFn,
    } = props

    return (
        <div className="amenity-form">
            <QuickForm
                showErrors={true}
                initialData={{
                    slug: '',
                    title: '',
                    description: '',
                    image: '',
                    icon: '',
                    tags: [],
                    tempTag: '',
                    type: '',
                    basePrice: 0,
                    baseQuantity: 0,
                    isActive: true,
                    featured: false,
                    providerSettings: [],
                    ...(initialValues ? {
                        ...initialValues,
                        tags: initialValues.tags ? initialValues.tags.map((t: string) => ({ tag: t })) : [],
                        tempTag: '',
                    } : {}),
                }}
                fields={[
                    {
                        fieldName: 'slug',
                        fieldLabel: 'Slug',
                        fieldType: 'text',
                        placeholder: 'Slug',
                        required: true,
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'title',
                        fieldLabel: 'Title',
                        fieldType: 'text',
                        placeholder: 'Title',
                        required: true,
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'description',
                        fieldLabel: 'Description',
                        fieldType: 'textarea',
                        placeholder: 'Description',
                        layout: { xs: 12 },
                    },
                    // image upload text and upload field
                    {
                        fieldName: 'image',
                        fieldLabel: 'Image',
                        fieldType: 'text',
                        placeholder: 'Image',
                        layout: { xs: 12 },
                        extra: {
                            title: 'Image URL',
                        },
                    },
                    {
                        fieldName: 'image',
                        fieldLabel: 'Image',
                        fieldType: 'imageUpload',
                        placeholder: 'Upload Image',
                        layout: { xs: 12 },
                        extra: {
                            imagePreview: true,
                        },
                    },
                    // icon upload text and upload field
                    {
                        fieldName: 'icon',
                        fieldLabel: 'Icon',
                        fieldType: 'text',
                        placeholder: 'Icon',
                        layout: { xs: 12 },
                        extra: {
                            title: 'Icon URL',
                        },
                    },
                    {
                        fieldName: 'icon',
                        fieldLabel: 'Icon',
                        fieldType: 'imageUpload',
                        placeholder: 'Upload Icon',
                        layout: { xs: 12 },
                        extra: {
                            imagePreview: true,
                        },
                    },
                    {
                        fieldName: 'type',
                        fieldLabel: 'Type',
                        fieldType: 'select',
                        placeholder: '- Select Type -',
                        required: true,
                        options: [
                            { value: 'included', text: 'Included' },
                            { value: 'paid', text: 'Paid' },
                        ],
                        layout: { xs: 12},
                        extra: {
                            title: 'Configuration',
                        },
                    },
                    {
                        fieldName: 'basePrice',
                        fieldLabel: 'Base Price',
                        fieldType: 'number',
                        placeholder: 'Base Price',
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'baseQuantity',
                        fieldLabel: 'Base Quantity',
                        fieldType: 'number',
                        placeholder: 'Base Quantity',
                        layout: { xs: 12, md: 6 },
                    },
                    {
                        fieldName: 'tags',
                        fieldLabel: 'Tags',
                        fieldType: 'quickTag',
                        placeholder: 'Tags',
                        layout: { xs: 12 },
                        extra: {
                            title: 'Tags',
                            tempFieldName: 'tempTag',
                            tagEntryName: 'tag',
                            buttons: AMENITY_TAG_OPTIONS,
                            options: {},
                        },
                    },
                    {
                        fieldName: 'isActive',
                        fieldLabel: 'Active',
                        fieldType: 'checkbox',
                        layout: { xs: 12 },
                        extra: {
                            title: 'Status',
                        },
                    },
                    {
                        fieldName: 'featured',
                        fieldLabel: 'Featured',
                        fieldType: 'checkbox',
                        layout: { xs: 12 },
                    },
                    {
                        fieldName: 'providerSettings',
                        fieldLabel: 'Provider Settings',
                        fieldType: 'custom',
                        layout: { xs: 12 },
                        extra: {
                            title: 'Provider Settings',
                            component: ProviderSettingsField,
                        },
                    },
                ]}
                disabled={disabled}
                uploadImageFn={uploadImageFn}
                onSubmit={(values: any) => {
                    const { tempTag, ...submitValues } = values
                    const tags = submitValues.tags
                        ? submitValues.tags.map((t: any) => t.tag)
                        : []
                    onSubmit({ ...submitValues, tags })
                }}
            />
        </div>
    )
}
